import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import { z } from "zod";

export const ResetPasswordSchema = z.object({
  password: z.string().min(8),
  email: z.string().email(),
  resetCode: z.string().min(6),
});

export type ResetPasswordSchemaType = z.infer<typeof ResetPasswordSchema>;

export async function resetPassword(data: ResetPasswordSchemaType) {
  return axiosInstance
    .post(`${config.apiUrl}/auth/reset-password`, { ...data })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
}
